import { ButtonSection } from './ButtonSection'
import { FooterSection } from './FooterSection'
import { PriceSection } from './PriceSection'
import { SalesAgentSection } from './SalesAgentSection'
import { VendorSection } from './VendorSection'

export const Section = {
  Button: ButtonSection,
  Price: PriceSection,
  Footer: FooterSection,
  SalesAgent: SalesAgentSection,
  Vendor: VendorSection
}
